if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.error = false;
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      console.log("SSSSSSS");
      console.log(evt);
      evt.preventDefault();

      let quantity = 1;
      const activeVariant = document.querySelector('.ultra__variantsoption.active');
      if (activeVariant && activeVariant.hasAttribute('data-qty')) {
        quantity = parseInt(activeVariant.getAttribute('data-qty'), 10);
      }

      const data = {
        id: evt.target.querySelector('[name="id"]').value,
        quantity: quantity
      };
      console.log(data);
      if(this.submitButton.classList.contains("byob-qv-btn")){
        console.log("bundle info", data)
        if(baseCard){
          baseCard.querySelector(".quick-add input[name='id']").value = data.id
          baseCard.querySelector(".quick-add input[name='quantity']").value = data.quantity
          if(activeVariant){
            baseCard.querySelector(".quick-add input[name='price']").value = activeVariant.querySelector(".ultra__variantInner span strong").dataset.price.replace("$","")
          }
          baseCard.querySelector(".bundle-atc").click()
          byob_qv_modal.close()
          return
        }
      }
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();
      if (!this.error) {
        gtag('event', "PDP add to cart", {
          'event_label': this.form.querySelector('[name=id]').value,
        });

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        this.updateCounter();

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
          .then(response => response.json())
          .then(response => {
            console.log('res:', response);
            openCart();
            const submitButtons = document.querySelectorAll('.product-form__submit');
            submitButtons.forEach(button => {
              button.classList.remove('loading');
              button.removeAttribute('aria-disabled');
            });

            const spinners = document.querySelectorAll('.loading-overlay__spinner');
            spinners.forEach(spinner => {
              spinner.classList.add('hidden');
            });
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      }
    }

    updateCounter() {
      const counter = document.querySelector('.cart-count-bubble > span:first-child');
      const current_count = parseInt(counter.innerHTML);
      const formQty = parseInt(this.form.querySelector('[name=quantity]').value);

      counter.innerHTML = current_count + formQty;
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;

        this.error = true;
      }
    }
  });
}
